export default {"src":"/_next/static/media/article_24.3e4f55aa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};